interface MenuItem {
  icon: string;
  name: string;
  desc: string;
  tag?: string;
  tagColor?: string;
  image: string;
  imageAlt: string;
}

const menuItems: MenuItem[] = [
  {
    icon: '🍕',
    name: 'マルゲリータ',
    desc: 'トマト、モッツァレラ、バジル。シンプルだから、生地のおいしさがいちばんわかる一枚。',
    tag: '定番',
    tagColor: 'bg-kiln text-white',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/7da2ec86d39daf22d34ddfc2282863bb.webp',
    imageAlt: 'マルゲリータピザ',
  },
  {
    icon: '🍕',
    name: 'ジェノベーゼ',
    desc: 'バジルソースの香りが口いっぱいに広がります。迷ったらこれ、というファンも多い一枚。',
    tag: '定番',
    tagColor: 'bg-kiln text-white',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/0a7f5f28dac7ac23a969d3d47056f8d8.webp',
    imageAlt: 'ジェノベーゼピザ',
  },
  {
    icon: '🍕',
    name: '照り焼きマヨチキン',
    desc: '焦がし醤油のチキンにマヨネーズ。和風ピザが好きなら、まずこれを食べてみてください。',
    tag: '人気',
    tagColor: 'bg-tankan text-white',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/4e13af2869443c278b8fb7edd8f0d1c3.webp',
    imageAlt: '照り焼きチキンピザ',
  },
  {
    icon: '🍕',
    name: 'ミックスピザ',
    desc: 'ピーマン、ソーセージ、コーン。みんなで分けるならこれがいちばん。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/5fc8275e6b2c9ff4cdc4596e9802d169.webp',
    imageAlt: 'ミックスピザ',
  },
  {
    icon: '🐟',
    name: 'フィッシュ＆チップス',
    desc: 'ピザだけじゃないんです。サクッと揚がった島の魚もぜひ。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/b077f42223c5c2968a2a277881747e4b.webp',
    imageAlt: 'フィッシュ＆チップス',
  },
  {
    icon: '🍕',
    name: '期間限定ピザ',
    desc: '中身はそのときのお楽しみ。気になったら聞いてくださいね。',
    tag: '季節限定',
    tagColor: 'bg-uken text-white',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/f1f79cd9523b07ba0f1b4bcea6913f76.webp',
    imageAlt: '期間限定お楽しみピザ',
  },
  {
    icon: '🍹',
    name: 'パンナコッタ・たんかんジュース',
    desc: '100％生絞りのたんかんジュース。焼きたてピザのお供にぴったり。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/d14621b8bbf7ab7a7106d734e81b321b.webp',
    imageAlt: 'パンナコッタ・たんかんジュース',
  },
  {
    icon: '🌿',
    name: 'よもぎ餅',
    desc: '奄美のお母さんたちから受け継いだ、島のおやつ。（4月〜）',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/32e88d033e6e7a193659022bf0f0a98f.webp',
    imageAlt: 'よもぎ餅',
  },
  {
    icon: '🍞',
    name: '懐かしいパンコーナー',
    desc: 'バナナパンや丸パン。どこか懐かしい味がします。',
    image: 'https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/4cd23f3e7a15c0c5445eef79fa9b427a.jpeg',
    imageAlt: '懐かしいパンコーナー',
  },
];

export default function Menu() {
  return (
    <section id="menu" className="bg-white py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / MENU
          </span>
          <p className="text-kiln/90 font-rounded text-base md:text-lg mb-5" style={{ lineHeight: '1.9' }}>
            焼きたてを持った瞬間、手に伝わる熱さと香ばしさ。<br />
            これがあるから、また来たくなるんです。
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-kiln">
            きょうは、どれにする？
          </h2>
          <p className="mt-4 text-kiln/80 font-rounded text-sm">
            ※数に限りがあるので、確実に食べたい方は予約がおすすめです。
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-cream rounded-2xl overflow-hidden group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                {item.tag && (
                  <span className={`absolute top-3 left-3 text-xs font-rounded font-bold px-3 py-1 rounded-full ${item.tagColor}`}>
                    {item.tag}
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="text-lg font-rounded font-black text-kiln mb-1">
                  {item.icon} {item.name}
                </h3>
                <p className="text-kiln/90 font-rounded text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ─── メニュー表 ─── */}
        <div className="mt-20">
          <div className="text-center mb-10">
            <span className="inline-block bg-tankan/10 text-tankan text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
              / PRICE LIST
            </span>
            <h2 className="text-2xl md:text-3xl font-rounded font-black text-kiln">
              メニュー・お品書き
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

            {/* 1. PIZZA */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">🍕</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">PIZZA</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">ピザ</h3>
                </div>
              </div>
              <p className="text-xs font-rounded text-kiln/80 mb-4 border-l-2 border-tankan/30 pl-3">
                テイクアウト（持ち帰り）の場合、箱代が別途 1個につき <strong>100円</strong> かかります。
              </p>
              <ul className="space-y-3">
                {[
                  { name: 'マルゲリータ', price: '1,200円', badge: '' },
                  { name: 'ジェノベーゼ（バジルソース）', price: '1,500円', badge: '' },
                  { name: '塩豚（ニンニク）フルソース', price: '1,500円', badge: '期間限定' },
                  { name: 'ミックス（コーン・玉ねぎ・ピーマン・ソーセージ）', price: '1,500円', badge: '' },
                  { name: '照り焼きマヨチキン', price: '1,500円', badge: 'NEW' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="flex items-center gap-2 font-rounded text-sm text-kiln">
                      {item.name}
                      {item.badge && (
                        <span className={`text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${item.badge === 'NEW' ? 'bg-tankan text-white' : 'bg-uken text-white'}`}>
                          {item.badge}
                        </span>
                      )}
                    </span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 2. COFFEE & CAFE */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">☕</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">COFFEE &amp; CAFE</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">コーヒー・ラテ</h3>
                </div>
              </div>
              <p className="text-xs font-rounded text-kiln/80 mb-4 border-l-2 border-tankan/30 pl-3">
                各種、アイスとホットからお選びいただけます（価格は同一です）。
              </p>
              <ul className="space-y-3">
                {[
                  { name: 'コーヒー', price: '380円' },
                  { name: 'カフェ・ラテ', price: '450円' },
                  { name: 'キャラメル・ラテ', price: '500円' },
                  { name: 'カフェ・モカ', price: '500円' },
                  { name: 'バニラ・ラテ', price: '500円' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{item.name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 3. SOFT DRINK */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">🥤</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">SOFT DRINK</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">ソフトドリンク</h3>
                </div>
              </div>
              <p className="text-xs font-rounded text-kiln/80 mb-4 border-l-2 border-tankan/30 pl-3">
                全品 <strong>300円</strong>
              </p>
              <ul className="space-y-3">
                {['オレンジ', 'りんご', 'コーラ', 'ウーロン茶'].map((name, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">300円</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 4. ALCOHOL */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">🍺</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">ALCOHOL</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">アルコール</h3>
                </div>
              </div>
              <p className="text-xs font-rounded font-bold text-kiln/80 mb-2 tracking-wider">お酒</p>
              <ul className="space-y-3 mb-5">
                {[
                  { name: '生ビール', price: '600円' },
                  { name: 'のんある（ノンアルコール）', price: '400円' },
                  { name: '角ハイボール', price: '550円' },
                  { name: 'ホワイトホース', price: '480円' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{item.name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs font-rounded font-bold text-kiln/80 mb-2 tracking-wider">サワー（全品 500円）</p>
              <ul className="space-y-3">
                {['無糖レモン', 'パイン', 'バイス'].map((name, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">500円</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 5. DESSERT & SWEETS */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">🍦</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">DESSERT &amp; SWEETS</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">デザート・ソフトクリーム</h3>
                </div>
              </div>
              <p className="text-xs font-rounded font-bold text-kiln/80 mb-2 tracking-wider">ソフトクリーム</p>
              <ul className="space-y-3 mb-5">
                {[
                  { name: '単品', price: '400円' },
                  { name: '各種フレーバー（チョコ・みかん・甘夏・ポメロ）', price: '各500円' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{item.name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs font-rounded font-bold text-kiln/80 mb-2 tracking-wider">デザート</p>
              <ul className="space-y-3">
                {[
                  { name: 'パンナコッタ', price: '220円', note: 'ブルーベリー・甘夏などのバリエーションあり' },
                  { name: 'ケーキセット', price: '800円', note: '' },
                  { name: 'ケーキ単品', price: '500円', note: '' },
                ].map((item, i) => (
                  <li key={i} className="flex items-start justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">
                      {item.name}
                      {item.note && <span className="block text-xs text-kiln/70 mt-0.5">※{item.note}</span>}
                    </span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* 6. LIGHT MEAL */}
            <div className="bg-cream rounded-2xl p-7">
              <div className="flex items-center gap-2 mb-5">
                <span className="text-2xl">🐟</span>
                <div>
                  <p className="text-xs font-rounded font-bold text-tankan tracking-widest">LIGHT MEAL</p>
                  <h3 className="text-xl font-rounded font-black text-kiln">軽食</h3>
                </div>
              </div>
              <ul className="space-y-3">
                {[
                  { name: 'ポテトフライ', price: '300円' },
                  { name: 'フィッシュ＆チップス', price: '850円' },
                ].map((item, i) => (
                  <li key={i} className="flex items-center justify-between gap-3 py-2 border-b border-kiln/10 last:border-0">
                    <span className="font-rounded text-sm text-kiln">{item.name}</span>
                    <span className="font-rounded font-black text-kiln text-sm whitespace-nowrap">{item.price}</span>
                  </li>
                ))}
              </ul>
              <div className="w-full h-44 rounded-xl overflow-hidden mt-5">
                <img
                  src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/2314102de4a685a980ff6b059fd67f18.webp"
                  alt="キャッシュレス決済対応"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

          </div>
        </div>
        {/* ─── /メニュー表 ─── */}

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="tel:0997-69-4091"
            className="inline-flex items-center gap-3 bg-kiln text-white font-rounded font-bold text-base px-10 py-4 rounded-full cursor-pointer hover:bg-kiln-dark transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line text-lg" />
            0997-69-4091 で予約できます
          </a>
          <p className="mt-3 text-kiln/80 font-rounded text-xs">電話予約を受け付けています</p>
        </div>
      </div>
    </section>
  );
}
